import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCf8: [],
		cf8: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	mutations: {
		set(state, cf8) {
			state.cf8 = cf8
			if (cf8)
				state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cf8 = null
		},
		setParamsDataTable(state, payload) {
			state.lstCf8 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLstCf3(state, payload) {
			state.cf8.lstCf3 = payload
		}
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, cf8regiao) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Address/Region/Find/${cf8regiao}`)
				.then(response => {
					let cf8 = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cf8)
					store.dispatch("cf3/setLstCf3", cf8.lstCf3, { root: true })
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			store.state.loading = false
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.post("/Address/Region/Insert", store.state.cf8)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/regioes")
					store.state.cf8 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.put("/Address/Region/Update", store.state.cf8)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/regioes")
					store.state.cf8 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.delete(`/Address/Region/Delete/${store.state.cf8.cf8regiao}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/regioes")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get("/Address/Region/FindList")
				.then(response => {
					let lstCf8 = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCf8 = lstCf8
					store.state.hasNext = lstCf8.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCf8 = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Address/Region/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCf8 = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
			return payload
		},
		async findRegion({ dispatch }, cf9regiao) {
			return await this._vm.$axios
				.get(`/Address/Region/Find/${cf9regiao}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return null;
				});
		},
	}
}
